module.exports = __webpack_public_path__ + "img/DiNapoli-6.a01fcc29.jpg";